import mdbVectorMap from "./components/VectorMap";

export default mdbVectorMap;

export { mdbVectorMap };
